var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preticker = exports.Liveticker = exports.TeamLogo = exports.MatchStatus = exports.TeamName = exports.Info = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("moment/locale/de");

var _moment = _interopRequireDefault(require("moment"));

var _get = _interopRequireDefault(require("lodash/get"));

var _index = _interopRequireDefault(require("../../../../../i18n/index"));

var _MatchComponents = require("../../../Match/MatchComponents");

var _Logos = require("../../../Basic/Logos");

var _Layouting = require("../../../Basic/Layouting");

var _Basic = require("../../../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../../../Basic/Touchable"));

var _PropsHelper = require("../../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Header/Components/HeaderComponents.js";

var Info = function Info(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    my: 1,
    numberOfLines: 1
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }), children);
};

exports.Info = Info;

var TeamName = function TeamName(_ref2) {
  var name = _ref2.name,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["name"]);
  return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    width: 1,
    center: true,
    numberOfLines: 1,
    bold: true
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }), name);
};

exports.TeamName = TeamName;

var MatchStatus = function MatchStatus(_ref3) {
  var matchInfo = _ref3.matchInfo,
      homeHalfScore = _ref3.homeHalfScore,
      awayHalfScore = _ref3.awayHalfScore,
      isLive = _ref3.isLive;
  if (!matchInfo) return null;
  if (isLive) return _react.default.createElement(_MatchComponents.LiveMinute, {
    minute: matchInfo.matchMinute,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 24
    }
  });

  switch (matchInfo.resultType) {
    case 'POSTPONED':
      return _react.default.createElement(Info, {
        py: 0,
        px: 2,
        bg: "background.secondary",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48,
          columnNumber: 17
        }
      }, (0, _index.default)('match_postponed'));

    case 'ABANDONED':
      return _react.default.createElement(Info, {
        py: 0,
        px: 2,
        bg: "background.secondary",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 17
        }
      }, (0, _index.default)('match_abandoned'));

    case 'AFTER_EXTRA_TIME':
      return _react.default.createElement(Info, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59,
          columnNumber: 20
        }
      }, "n.V.");

    case 'PENALTY_SHOOTOUT':
      return _react.default.createElement(Info, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61,
          columnNumber: 20
        }
      }, "n.E.");

    case 'NORMAL_RESULT':
    case 'AGGREGATE':
      return _react.default.createElement(_MatchComponents.MatchScore, {
        bold: false,
        homeScore: homeHalfScore,
        awayScore: awayHalfScore,
        my: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 17
        }
      });

    default:
      return null;
  }
};

exports.MatchStatus = MatchStatus;

var TeamLogo = function TeamLogo(_ref4) {
  var team = _ref4.team,
      onPress = _ref4.onPress,
      href = _ref4.href,
      NavWrapper = _ref4.NavWrapper;
  return _react.default.createElement(_Touchable.default, {
    onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, team),
    href: href,
    NavWrapper: NavWrapper,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 5
    }
  }, _react.default.createElement(_Logos.TeamLogo, {
    size: 56,
    src: (0, _get.default)(team, 'imageUrl'),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 9
    }
  }));
};

exports.TeamLogo = TeamLogo;
TeamLogo.propTypes = {
  team: _propTypes.default.object.isRequired,
  onPress: _propTypes.default.func
};

var Liveticker = function Liveticker(_ref5) {
  var homeTeam = _ref5.homeTeam,
      awayTeam = _ref5.awayTeam,
      homeScore = _ref5.homeScore,
      awayScore = _ref5.awayScore,
      matchInfo = _ref5.matchInfo,
      homeHalfScore = _ref5.homeHalfScore,
      awayHalfScore = _ref5.awayHalfScore,
      homePenaltyScore = _ref5.homePenaltyScore,
      awayPenaltyScore = _ref5.awayPenaltyScore,
      isLive = _ref5.isLive,
      onPressTeam = _ref5.onPressTeam,
      createTeamHref = _ref5.createTeamHref,
      NavWrapper = _ref5.NavWrapper;
  return _react.default.createElement(_Basic.View, {
    mb: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 5
    }
  }, _react.default.createElement(_Layouting.ChildrenToRow, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 9
    }
  }, _react.default.createElement(TeamLogo, {
    team: homeTeam,
    onPress: onPressTeam,
    href: (0, _PropsHelper.executeFunctionOrUndefined)(createTeamHref, homeTeam),
    NavWrapper: NavWrapper,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 13
    }
  }), _react.default.createElement(_MatchComponents.MatchScore, (0, _extends2.default)({
    size: "largest",
    my: 2
  }, {
    homeScore: homeScore,
    awayScore: awayScore,
    homePenaltyScore: homePenaltyScore,
    awayPenaltyScore: awayPenaltyScore
  }, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 13
    }
  })), _react.default.createElement(TeamLogo, {
    team: awayTeam,
    onPress: onPressTeam,
    href: (0, _PropsHelper.executeFunctionOrUndefined)(createTeamHref, awayTeam),
    NavWrapper: NavWrapper,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 13
    }
  })), _react.default.createElement(_Layouting.ChildrenToRow, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 9
    }
  }, _react.default.createElement(TeamName, {
    name: (0, _get.default)(homeTeam, 'shortName') || (0, _get.default)(homeTeam, 'name'),
    my: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 13
    }
  }), _react.default.createElement(MatchStatus, (0, _extends2.default)({
    matchInfo: matchInfo,
    homeHalfScore: homeHalfScore,
    awayHalfScore: awayHalfScore,
    isLive: isLive
  }, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 13
    }
  })), _react.default.createElement(TeamName, {
    name: (0, _get.default)(awayTeam, 'shortName') || (0, _get.default)(awayTeam, 'name'),
    my: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 13
    }
  })));
};

exports.Liveticker = Liveticker;

var Preticker = function Preticker(_ref6) {
  var scheduledStartTime = _ref6.scheduledStartTime,
      homeTeam = _ref6.homeTeam,
      awayTeam = _ref6.awayTeam,
      onPressTeam = _ref6.onPressTeam,
      createTeamHref = _ref6.createTeamHref,
      NavWrapper = _ref6.NavWrapper;
  return _react.default.createElement(_Basic.Row, {
    mb: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 5
    }
  }, _react.default.createElement(_Layouting.ChildrenToColumnWithStyle, {
    columnStyling: {
      center: true,
      flexing: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 9
    }
  }, _react.default.createElement(TeamLogo, {
    team: homeTeam,
    onPress: onPressTeam,
    href: (0, _PropsHelper.executeFunctionOrUndefined)(createTeamHref, homeTeam),
    NavWrapper: NavWrapper,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 13
    }
  }), _react.default.createElement(TeamName, {
    name: homeTeam.shortName || homeTeam.name,
    my: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 13
    }
  })), _react.default.createElement(_Layouting.ChildrenToColumnWithStyle, {
    columnStyling: {
      center: true,
      flexing: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 9
    }
  }, scheduledStartTime ? [_react.default.createElement(Info, {
    key: "date-string",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 23
    }
  }, (0, _moment.default)(scheduledStartTime).format('L')), _react.default.createElement(Info, {
    key: "time-string",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 23
    }
  }, (0, _moment.default)(scheduledStartTime).format('LT'))] : null), _react.default.createElement(_Layouting.ChildrenToColumnWithStyle, {
    columnStyling: {
      center: true,
      flexing: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 9
    }
  }, _react.default.createElement(TeamLogo, {
    team: awayTeam,
    onPress: onPressTeam,
    href: (0, _PropsHelper.executeFunctionOrUndefined)(createTeamHref, awayTeam),
    NavWrapper: NavWrapper,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 13
    }
  }), _react.default.createElement(TeamName, {
    name: awayTeam.shortName || awayTeam.name,
    my: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 13
    }
  })));
};

exports.Preticker = Preticker;